var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"h5Maker"}},[_c('app-header',{attrs:{"type":"h5"}}),_c('app-body',{attrs:{"type":"h5"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }